import { FunctionComponent } from "react";
import { Button } from "antd";
import { LoginOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

export const PublicHeader: FunctionComponent = () => {
    const navigate = useNavigate();
    return (
        <div className="public-header">
            <button type="button" className="public-header-brand" onClick={() => navigate("/")} aria-label="Accueil">
                <span className="logo" />
                <span className="logo-title">Association musulmane du Chablais</span>
            </button>
            <Button type="primary" icon={<LoginOutlined />} onClick={() => navigate("/login")}>
                Se connecter
            </Button>
        </div>
    );
};
